Namespace.create("cv.Views").SetupView = Marionette.LayoutView.extend({
  template: cv.Templates["setup/view"],

  className: "view-setup",

  regions: {
    region_content: "#region-content",
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    show: function () {
      // Update the h2 text
      this.$("h2").text("Join " + cv.campaign.get("title"));

      // Update the styles
      this.updateStyles();
    },
    render: function () {
      // Update the h2 text
      this.$("h2").text("Join " + cv.campaign.get("title"));

      // Update the styles
      this.updateStyles();
    },
  },

  events: {
    "click .back": function (e) {
      e.preventDefault();

      vent.trigger("setup:prev_screen");
    },
    "click .view-setup__nav a": "clickNav",
  },

  validation: {},

  templateHelpers: function () {
    return {};
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // The array holding all screens for this setup
    if (cv.campaign.get("enable_p2p_registrations") == 1) {
      this.screens = [
        {
          screen: "profile",
          label: "Finish Your Profile",
        },
        {
          screen: "registration",
          label: "Pay Registration Fee",
        },
        {
          screen: "page",
          label: "Set Up Fundraising Page",
        },
        {
          screen: "appeal",
          label: "Write Your Appeal",
        },
        {
          screen: "share",
          label: "Share With Friends",
        },
      ];
    } else {
      this.screens = [
        {
          screen: "profile",
          label: "Finish Your Profile",
        },
        {
          screen: "page",
          label: "Set Up Fundraising Page",
        },
        {
          screen: "appeal",
          label: "Write Your Appeal",
        },
        {
          screen: "share",
          label: "Share With Friends",
        },
      ];
    }

    // Model
    this.model = new Backbone.Model({
      screen: "",
    });

    this.listenTo(
      this.model,
      "change:screen",
      function () {
        this.renderSidebar(this.model.get("screen"));
        this.renderScreen(this.model.get("screen"));

        cv.router.navigate("fundraiser_setup/" + this.model.get("screen"), { replace: true });
      },
      this
    );

    this.listenTo(vent, "setup:prev_screen", this.previousScreen, this);
    this.listenTo(vent, "setup:next_screen", this.nextScreen, this);
    this.listenTo(vent, "setup:process_stripe", this.processStripe, this);
  },

  previousScreen: function () {
    console.log("Advancing to previous screen...");

    var screen_index = this.screens
      .map(function (e) {
        return e.screen;
      })
      .indexOf(this.model.get("screen"));
    this.model.set("screen", this.screens[screen_index - 1].screen);
  },

  nextScreen: function () {
    console.log("Advancing to next screen...");

    var screen_index = this.screens
      .map(function (e) {
        return e.screen;
      })
      .indexOf(this.model.get("screen"));
    this.model.set("screen", this.screens[screen_index + 1].screen);
  },

  clickNav: function (e) {
    e.preventDefault();

    var screen = $(e.currentTarget).parent().data("link");
    this.model.set("screen", screen);
  },

  renderSidebar: function (screen) {
    var blah = false;

    // Reset any old styles
    this.$(".view-setup__nav li").removeAttr("style");
    this.$(".view-setup__nav li .step").removeAttr("style");
    this.$(".step").removeClass("step-dark step-light");
    this.$(".step-label").removeClass("step-dark step-light");

    if (cv.campaign.get("id") == "mPDedW10BVka2RVM") {
      this.$(".step").addClass("step-dark");
      this.$(".step-label").addClass("step-dark");
    } else {
      this.$(".step").addClass("step-light");
      this.$(".step-label").addClass("step-light");
    }

    // Build the navigation styles
    _.each(
      this.screens,
      function (item, index, list) {
        if (blah == false) {
          if (item.screen == screen) {
            this.$('li[data-link="' + item.screen + '"]')
              .removeClass("active complete")
              .addClass("active");
            this.$('li[data-link="' + item.screen + '"] .step')
              .removeAttr("data-color data-background")
              .attr("data-color", "main_color");
            blah = true;
          } else {
            this.$('li[data-link="' + item.screen + '"]')
              .removeClass("active complete")
              .addClass("complete");
            this.$('li[data-link="' + item.screen + '"] .step')
              .removeAttr("data-color data-background")
              .attr("data-background", "accent_color");
          }
        } else {
          this.$('li[data-link="' + item.screen + '"]').removeClass("active complete");
          this.$('li[data-link="' + item.screen + '"] .step').removeAttr(
            "data-color data-background"
          );
        }
      },
      this
    );

    this.$('li[data-link="' + screen + '"]').addClass("active");
    this.$('li[data-link="' + screen + '"] .step')
      .removeAttr("data-color data-background")
      .attr("data-color", "main_color");
  },

  renderScreen: function (screen) {
    // Show the view
    switch (screen) {
      case "registration":
        var view = new cv.Views.Setup.RegistrationPaymentView({
          model: cv.project,
        });
        break;
      case "page":
        var view = new cv.Views.Setup.PageView({
          model: cv.project,
        });
        break;
      case "appeal":
        var view = new cv.Views.Setup.AppealView({
          model: cv.project,
        });
        break;
      case "share":
        var view = new cv.Views.Setup.ShareView({
          model: cv.project,
        });
        break;
      case "profile":
      default:
        var view = new cv.Views.Setup.ProfileView({
          model: cv.user,
        });
    }
    this.showChildView("region_content", view);

    // Fade in and out
    this.$("#region-content > div").hide().fadeIn("fast");

    // Reset the scroll
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      100
    );
  },

  updateStyles: function () {
    // Change the color based on the background colors
    _.each(
      this.$("[data-color]"),
      function (el) {
        var color_attr = $(el).data("color");
        this.$(el).css("color", cv.campaign.get("branding." + color_attr) + " !important;");
      },
      this
    );

    _.each(
      this.$("[data-background]"),
      function (el) {
        var background_attr = $(el).data("background");
        var text_color = cv.getTextColor(cv.campaign.get("branding." + background_attr));
        this.$(el).css(
          "background-color",
          cv.campaign.get("branding." + background_attr) + " !important;"
        );
        this.$(el).css("color", text_color + " !important;");
      },
      this
    );
  },

  onAttach: function () {
    // Build the navigation
    _.each(
      this.screens,
      function (item, index, list) {
        this.$(".view-setup__nav ul").append(
          '<li data-link="' +
            item.screen +
            '">' +
            '<a class="step-label" href="#">' +
            item.label +
            "</a>" +
            '<div class="step">' +
            (index + 1) +
            "</div>" +
            "</li>"
        );
      },
      this
    );

    if (_.isNull(this.options.tab)) {
      this.options.tab = "profile";
    }
    this.model.set("screen", this.options.tab);
  },
});
